// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContactPerson } from './contact-person';

/**
 * 
 * @export
 * @interface PhysicalContractorEdit
 */
export interface PhysicalContractorEdit {
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    snils?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    postAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    education?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    educationSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    educationNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorEdit
     */
    educationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    educationRegistrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    educationSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    educationInstitution?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    citizenship?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicalContractorEdit
     */
    gender?: number;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorEdit
     */
    birthday?: Date;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    passportSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    passportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    passportIssuedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    whenPassportIssued?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    type: PhysicalContractorEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorEdit
     */
    comment?: string;
    /**
     * 
     * @type {ContactPerson}
     * @memberof PhysicalContractorEdit
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {Array<string>}
     * @memberof PhysicalContractorEdit
     */
    studentIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum PhysicalContractorEditTypeEnum {
    Juridical = 'juridical',
    Physical = 'physical'
}



